import { Typography } from 'fitify-ui-onboarding/src/components/Typography'
import { styled } from 'styled-components'

export const StyledDescriptionTerms = styled(Typography)`
  color: ${({ theme }) => theme.colors['N Content/Secondary']};
  text-align: center;

  a {
    color: ${({ theme }) => theme.colors['N Content/Secondary']};
  }
`
